<template>
  <h2
    class="subtitle"
  >
    <slot />
  </h2>
</template>
<script>
export default {
  name: 'SubTitle'
}
</script>
<style lang="scss" scoped>
  .subtitle {
  color: $question-subtitle-color;
  opacity: 0.8;
  letter-spacing: -0.64px;
  font-weight: 400;
  text-align: center;
  font-size: 15px;
  line-height: 16px;
  max-width: 288px;
  margin-bottom: 30px;

  @media (min-width: $screen-md) {
    max-width: 555px;
    font-size: 16px;
    line-height: 18px;
  }
}
</style>
